import service from "@/service/request.js";
//获取用户剩余点数 以及权益过期时间
export const balance = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/account/balance",
  method: "get",
  data
});

//获取个人定制微模型列表

export const microModelList = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/iyw-ai-net/api/LoraSettings/GetList",
  method: "post",
  data
});

//获取用户生成任务列表

export const taskList = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/iyw-ai-net/api/GenerateTask/GetList",
  method: "post",
  data
})
//删除任务或者图片
export const deteleTask = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/task/detele",
  method: "post",
  data
});

//微模型生成接口
export const generate = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/v2/generate",
  method: "post",
  data
});

//获取配置接口（尺寸，模型对应消耗点数等）
export const modelConfig = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/iyw-ai-net/api/ScaleConfig/GetList",
  method: "post",
  data
});

//获取配置接口（尺寸，模型对应消耗点数等）
export const getMateial = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/getMateial",
  method: "post",
  data
});

//获取配置接口（尺寸，模型对应消耗点数等）
export const RecvMsgParser = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/messagecenter/Message/RecvMsgParser",
  method: "post",
  data
});

//获取任务详情
export const microTask = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/iyw-ai-net/api/GenerateTask/GetDetails",
  method: "post",
  data
});


//获取个人信息
export const getUserInfo = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/user-service/user/getInfo",
  method: "post",
  data
});


//权益信息
export const GetAuthList = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/member/api/v2/MemberAuth/GetAuthList",
  method: "post",
  data
});

//mj查看大图
export const upscale = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/upscale",
  method: "post",
  data
});

//mj重绘图片
export const variation = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/variation",
  method: "post",
  data
});

//mj重新生成
export const reset = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/reset",
  method: "post",
  data
});

//优化提示词
export const upgradePrompt = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/upgradePrompt",
  method: "post",
  data
});

//反推提示词
export const describe = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-chat/api/chat/describe",
  method: "post",
  data
});
//重新生成
export const microRefresh = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/reset",
  method: "post",
  data
});
//检测图片
export const checkImage = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/checkImage",
  method: "post",
  data
});
//批量生成
export const batch = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/v2/batch",
  method: "post",
  data
});
//获取用户已经设置的图片
export const userCollect = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/userCollect",
  method: "post",
  data
});
//获取用户生成图片历史记录
export const collects = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/collects",
  method: "post",
  data
});
//设置喜欢
export const addCollect = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/addCollect",
  method: "post",
  data
});
//设置移除喜欢
export const removeCollect = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/removeCollect",
  method: "post",
  data
});

// 刷新token
export const refreshToken = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "sso/api/sso/web/renewToken?refreshToken=" + data,
  method: "get"
});

//新建AI对话
export const createNewChat = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/createNewChat",
  method: "post",
  data
});

//发送AI对话
export const sendChat = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/chat",
  method: "post",
  data
});

//获取趋势信息
export const OptimizePrompt = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-chat/api/trender/OptimizePrompt",
  method: "post",
  data
});


export const inpaintApi = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/inpaint",
  method: "post",
  data
});
export const getToolsResults = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/getCommerceTaskDetail",
  method: "post",
  data
});

// 获取行业、服务类型
export const getByKey = params => service({
  aseURL: process.env.VUE_APP_DESIGN_BASE,
  url: "/account-search/basic/dict/getByKey",
  method: "get",
  params,
  saasToken: false,

});

//获取微模型列表
export const LoraSettings = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/iyw-ai-net/api/LoraSettings/GetList",
  method: "post",
  data
});

export const getRecommendList = data => service({
aseURL: process.env.VUE_APP_API,
url: "/opensearch-service/apply/recommend/page",
method: "post",
data
})

export const getPatternModelList = data => service({
    aseURL: process.env.VUE_APP_API,
    url: "/opensearch-service/apply/getMyPatternApply",
    method: "post",
    data
})

export const getMyDesignApply = data => service({
    aseURL: process.env.VUE_APP_API,
    url: "/opensearch-service/apply/getMyDesignApply",
    method: "post",
    data
})

export const recommendImgGenerate = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/faddish/generate",
    method: "post",
    data
});

//应用获取
export const getMyApply = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/opensearch-service/apply/getMyApply",
    method: "post",
    data
});

//搜索当前部门下成员
export const employeeDeptList = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/user-service/employee/employeeDeptList",
    method: "post",
    data
});

//搜索创意拓展历史记录
export const history = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/chat/history",
    method: "post",
    data
});

//获取趋势列表
export const GetTrendList = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/theme-activity/api/Trend/GetTrendList",
    method: "post",
    data
});

//获取趋势详情
export const GetTrendDetail = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/theme-activity/api/Activitys/GetActivityDetail",
    method: "post",
    data
});

//获取方案
export const designScheme = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/chat/designScheme",
    method: "post",
    data
});

//生成ai图
export const generateImage = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/generateImage",
    method: "post",
    data
});

//策划生成列表
export const schemeList = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/list",
    method: "post",
    data
});

//查询图片列表
export const searchGenerateResult = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/searchGenerateResult",
    method: "post",
    data
});

//策划详情
export const schemeDetail = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/detail",
    method: "post",
    data
});

//删除策划图片
export const deleteImage = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/deleteImage",
    method: "post",
    data
});

//获取趋势列表
export const GetTrenderList = data => service({
    baseURL: process.env.VUE_APP_API,
    url: "ai-chat/api/trender/GetTrenderList",
    method: "post",
    data
});


